import { selectMenuStyles, SelectWrapper } from '@arnold/common';
import { useTranslation } from 'react-i18next';
import { PlaceHolder } from '../../components/SelectFilterHelpers';
import { CustomSingleValue } from './StyledComponents';

export enum OrderBy {
  BEST_FIRST = 'bestFirst',
  WORST_FIRST = 'worstFirst',
}

interface IProps {
  className?: string;
  orderBy: OrderBy;
  setOrderBy: (orderBy: OrderBy) => void;
}

const PulserOrderSelect = ({ className, orderBy, setOrderBy }: IProps) => {
  const { t } = useTranslation('PulserReport');

  const compareFilterOptions = [
    { value: OrderBy.BEST_FIRST, label: t('bestFirst') },
    { value: OrderBy.WORST_FIRST, label: t('worstFirst') },
  ];

  const CustomSelectSelectedValue = (props: { getValue: () => { value: OrderBy }[] }) => {
    const selectedValue = props.getValue()[0];
    if (!selectedValue) {
      return null;
    }
    const foundOption = compareFilterOptions.find((option) => option.value === selectedValue.value);
    if (foundOption) {
      return <CustomSingleValue>{foundOption.label}</CustomSingleValue>;
    }
    return null;
  };

  return (
    <SelectWrapper
      blurInputOnSelect={false}
      menuShouldScrollIntoView={false}
      defaultValue={{ value: OrderBy.BEST_FIRST, label: t('bestFirst') }}
      className={`react-select ${className || ''}`}
      components={{
        IndicatorSeparator: () => null,
        SingleValue: CustomSelectSelectedValue,
        Placeholder: () => <PlaceHolder>{t('compareAnswersInGraphs')}</PlaceHolder>,
      }}
      styles={{
        menu: (provided: any, state: any) => ({
          ...provided,
          ...selectMenuStyles,
        }),
        container: (provided: any, state: any) => ({
          ...provided,
          width: '100% !important',
          margin: '0px',
        }),
      }}
      isSearchable={false}
      isMulti={false}
      /* tslint:disable-next-line:jsx-no-lambda */
      onChange={(opt: any) => setOrderBy(opt.value)}
      options={compareFilterOptions}
      menuPlacement="auto"
      value={compareFilterOptions.find((option) => option.value === orderBy)}
    />
  );
};

export default PulserOrderSelect;
